export const SET_CONTRACT = "SET_CONTRACT";
export const SET_CONTRACT_LIST = "SET_CONTRACT_LIST";
